import React, { useState } from "react";
import { connect } from "react-redux";

import {
  freeProduct,
  fixedAmount,
  freeShippingCoupon,
  percentageCoupon,
  giftcardIcon,
} from "../../helpers/icons";
import WaysToRedeemItem from "./WaysToRedeemItem";
import { BiArrowBack } from "react-icons/bi";
import FreeProductItem from "./FreeProductItem";
import {
  generateDiscountCode,
  generateFreeShippingCode,
  generatePercentageCode,
  generateTierDiscountCode,
  generateTierPercentCode,
  redeemFreeProduct,
  checkTierBenefitsEligibility,
} from "../../helpers/helpers";
import {
  fetchCustomer,
  setCurrentDiscountCode,
} from "../../actions/customerActions";
import { languages } from "../../helpers/language";
import { setIsDiscountCard } from "../../actions/appstateActions";
import RedeemPointsGiftcardItem from "./RedeemPointsGiftcardItem";
import { capitalizeFirstLetter } from "../../utils";
import FreeProductCategoryItem from "./FreeProductCategoryItem";
import RedeemPointsIncrementalCoupon from "./RedeemPointsIncrementalCoupon";

const WaysToRedeemSection = ({
  waysToRedeemRef,
  rewardsRef,
  merchantData,
  customerData,
  appStateData,
  fetchCustomer,
  setCurrentDiscountCode,
  setIsDiscountCard,
}) => {
  let { merchant, currencySymbol, sortedVipTeirs } = merchantData;
  let { customer } = customerData;
  let { customerId, shopDomain } = appStateData;

  const [loading, setLoading] = useState(false);
  const [isFreeProductActive, setIsFreeProductActive] = useState(false);
  const [activeFreeProducts, setActiveFreeProducts] = useState([]);
  const [isCategoryListView, setIsCategoryListView] = useState(true);

  let details = {
    redeem_fixed_coupon:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "redeem.percentage_coupon"
      ],
    main_points_title:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "main.points_title"
      ],
    points_spent:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "discount.points_spent"
      ],
    ways_to_redeem:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "main.ways_to_redeem"
      ],
  };

  const getVIPTierEligibility = (action, actionTier = "") => {
    if (!merchant?.isVipTiersActive || !customerId) return true;

    switch (action) {
      case "shipping":
        actionTier = merchant?.shippingCoupon?.eligibleVIPTier;
        break;

      case "giftcard":
        actionTier = merchant?.giftCardRedeemEligibleVIPTier;
        break;

      default:
        break;
    }

    if (!actionTier) return true;

    return checkTierBenefitsEligibility(
      sortedVipTeirs ?? [],
      customer?.tierName ?? "",
      actionTier
    );
  };

  return (
    <div ref={waysToRedeemRef} className="waysToRedeem-section-wrapper">
      <div className="waysToRedeem-heading-container">
        <h2 className="waysToRedeem-heading">
          {merchant?.currentPlan?.planName !== "free" &&
          merchant?.customWidgetTheme?.textCustomization
            ? merchant?.customWidgetTheme?.textCustomization?.waysToRedeem
            : details.ways_to_redeem}
        </h2>
      </div>
      {isFreeProductActive && (
        <div className="rewards-back-button-warpper">
          <button
            onClick={() => {
              setIsFreeProductActive((prev) => !prev);
            }}
            className="rewards-back-button"
          >
            <BiArrowBack className="rewards-back-button-icon" />
            {/* {details.rewards_go_back} */}
            {merchant?.currentPlan?.planName !== "free" &&
            merchant?.customWidgetTheme?.textCustomization
              ? merchant?.customWidgetTheme?.textCustomization?.goBackButton
              : "Go Back"}
          </button>
        </div>
      )}
      {isFreeProductActive && isCategoryListView && (
        <div className="freeProduct-category-container w-full flex flex-row flex-wrap justify-between fade px-3">
          {merchant?.freeProductList?.map((category) => {
            if (!category?.products) return null;
            if (category?.products?.length === 0) return null;
            const eligibleList = category?.products.filter((item) =>
              getVIPTierEligibility(item?.action, item?.eligibleVIPTier)
            );
            if (eligibleList.length === 0) return null;
            category.products = [...eligibleList];

            return (
              <FreeProductCategoryItem
                title={capitalizeFirstLetter(category?.category)}
                desc={
                  merchant?.currentPlan?.planName !== "free" &&
                  merchant?.customWidgetTheme?.textCustomization
                    ? merchant?.customWidgetTheme?.textCustomization
                        ?.listOfAllProducts
                    : "List of all Products"
                }
                onClickHandler={() => {
                  setActiveFreeProducts(category);
                  setIsCategoryListView((prev) => !prev);
                }}
                buttonText={
                  merchant?.currentPlan?.planName !== "free" &&
                  merchant?.customWidgetTheme?.textCustomization
                    ? merchant?.customWidgetTheme?.textCustomization?.viewButton
                    : "View"
                }
              />
            );
          })}
        </div>
      )}
      {isFreeProductActive && !isCategoryListView && (
        <div className="freeProduct-category-name ">
          <BiArrowBack
            onClick={() => setIsCategoryListView((prev) => !prev)}
            className="freeProduct-category-back-icon"
            size={20}
          />
          <h2>{activeFreeProducts.category}</h2>
        </div>
      )}
      <div className="waysToRedeem-items-warpper">
        {isFreeProductActive &&
          !isCategoryListView &&
          activeFreeProducts?.products?.map((item) => {
            return (
              <FreeProductItem
                key={item.id}
                imgUrl={item.products[0].images[0].src}
                text={item.products[0].title}
                desc={`${item.points} ${
                  merchant?.pointsCurrency !== "Super-Points"
                    ? merchant?.pointsCurrency
                    : "Points"
                }`}
                productHandle={item.products[0].handle}
                isButton={
                  customerId && customer?.points >= item.points ? true : false
                }
                buttonClickHandler={async () => {
                  if (
                    customerId && customer?.points >= item.points ? true : false
                  ) {
                    await redeemFreeProduct(
                      shopDomain,
                      customerId,
                      item.products[0].variants[0].id,
                      activeFreeProducts.id
                    );
                    await fetchCustomer(customerId, shopDomain);
                  }
                }}
              />
            );
          })}
        {isFreeProductActive &&
          isCategoryListView &&
          merchant?.freeProductRewardList?.map((item, index) => (
            <FreeProductItem
              key={index}
              imgUrl={item.products[0].images[0].src}
              text={item.products[0].title}
              desc={`${item.points} ${
                merchant?.pointsCurrency !== "Super-Points"
                  ? merchant?.pointsCurrency
                  : "Points"
              }`}
              productHandle={item.products[0].handle}
              isButton={
                customerId && customer?.points >= item.points ? true : false
              }
              buttonClickHandler={async () => {
                if (
                  customerId && customer?.points >= item.points ? true : false
                ) {
                  await redeemFreeProduct(
                    shopDomain,
                    customerId,
                    item.products[0].variants[0].id
                  );
                  await fetchCustomer(customerId, shopDomain);
                }
              }}
            />
          ))}

        {!isFreeProductActive && merchant?.waysToRedeem?.freeProduct && (
          <WaysToRedeemItem
            imgUrl={
              merchant?.theme?.icons?.freeProduct?.type === "custom"
                ? merchant?.theme?.icons?.freeProduct?.location
                : freeProduct(
                    merchant?.customWidgetTheme?.iconcolor || "#262626"
                  )
            }
            title={
              merchant?.currentPlan?.planName !== "free" &&
              merchant?.theme?.textCustomization?.earnType?.freeProduct
                ? merchant?.theme?.textCustomization?.earnType?.freeProduct
                : "Free Product"
            }
            desc={
              merchant?.currentPlan?.planName !== "free" &&
              merchant?.customWidgetTheme?.textCustomization
                ? merchant?.customWidgetTheme?.textCustomization
                    ?.listOfAllProducts
                : "List of all Products"
            }
            buttonText={
              merchant?.currentPlan?.planName !== "free" &&
              merchant?.customWidgetTheme?.textCustomization
                ? merchant?.customWidgetTheme?.textCustomization?.viewButton
                : "View"
            }
            isButton={true}
            disabled={false}
            onClickHandler={() => {
              setIsFreeProductActive((prev) => !prev);
            }}
          />
        )}

        {!isFreeProductActive &&
          merchant?.waysToRedeem?.shipping &&
          getVIPTierEligibility("shipping") && (
            <WaysToRedeemItem
              imgUrl={
                merchant?.theme?.icons?.shipping?.type === "custom"
                  ? merchant?.theme?.icons?.shipping?.location
                  : freeShippingCoupon(
                      merchant?.customWidgetTheme?.iconcolor || "#262626"
                    )
              }
              title={
                merchant?.currentPlan?.planName !== "free" &&
                merchant?.theme?.textCustomization?.earnType?.shipping
                  ? merchant?.theme?.textCustomization?.earnType?.shipping
                  : "Free Shipping"
              }
              desc={`${merchant?.shippingPoints} ${
                merchant?.pointsCurrency !== "Super-Points"
                  ? merchant?.pointsCurrency
                  : details.main_points_title
              }`}
              buttonText={
                merchant?.currentPlan?.planName !== "free" &&
                merchant?.customWidgetTheme?.textCustomization
                  ? merchant?.customWidgetTheme?.textCustomization?.redeemButton
                  : "Redeem"
              }
              isButton={
                customerId && customer?.points >= merchant?.shippingPoints
              }
              disabled={
                !(customerId && customer?.points >= merchant?.shippingPoints)
              }
              loading={loading}
              onClickHandler={async () => {
                if (
                  customerId &&
                  customer?.points >= merchant?.shippingPoints
                ) {
                  setLoading(true);

                  let { code, expiryDate } = await generateFreeShippingCode(
                    shopDomain,
                    customerId
                  );
                  setCurrentDiscountCode({
                    text:
                      merchant?.currentPlan?.planName !== "free" &&
                      merchant?.theme?.textCustomization?.earnType?.shipping
                        ? merchant?.theme?.textCustomization?.earnType?.shipping
                        : details?.rewards_shipping ?? "Free Shipping",
                    desc: `${merchant?.shippingPoints} ${
                      merchant?.pointsCurrency !== "Super-Points"
                        ? merchant?.pointsCurrency
                        : details.main_points_title
                    } ${details.points_spent}`,
                    code,
                    imgUrl: freeShippingCoupon("#262626"),
                    expiryDate,
                  });
                  await fetchCustomer(customerId, shopDomain);
                  setLoading(false);
                  setIsDiscountCard(true);

                  window.scrollTo({
                    top: window.innerWidth < 768 ? 500 : 200,
                    behavior: "smooth",
                  });
                }
              }}
            />
          )}
        {!isFreeProductActive &&
          merchant?.waysToRedeem?.fixed &&
          merchant?.couponAmt && (
            <WaysToRedeemItem
              imgUrl={
                merchant?.theme?.icons?.fixed?.type === "custom"
                  ? merchant?.theme?.icons?.fixed?.location
                  : fixedAmount(
                      merchant?.customWidgetTheme?.iconcolor || "#262626"
                    )
              }
              title={
                merchant?.currentPlan?.planName !== "free" &&
                merchant?.customWidgetTheme?.textCustomization
                  ? merchant?.customWidgetTheme?.textCustomization?.valueOffCoupon?.replace(
                      "{{value}}",
                      `${merchant?.currency?.symbol}${merchant?.couponAmt}`
                    )
                  : `${merchant?.currency?.symbol}${merchant?.couponAmt} ${
                      details.redeem_fixed_coupon.split("%")[1]
                    }`
              }
              desc={`${merchant?.redeemPoints} ${
                merchant?.pointsCurrency !== "Super-Points"
                  ? merchant?.pointsCurrency
                  : details.main_points_title
              }`}
              buttonText={
                merchant?.currentPlan?.planName !== "free" &&
                merchant?.customWidgetTheme?.textCustomization
                  ? merchant?.customWidgetTheme?.textCustomization?.redeemButton
                  : "Redeem"
              }
              isButton={
                customerId && customer?.points >= merchant?.redeemPoints
              }
              disabled={
                !(customerId && customer?.points >= merchant?.redeemPoints)
              }
              loading={loading}
              onClickHandler={async () => {
                if (customerId && customer?.points >= merchant?.redeemPoints) {
                  setLoading(true);

                  let code = await generateDiscountCode(shopDomain, customerId);
                  setCurrentDiscountCode({
                    text:
                      merchant?.currentPlan?.planName !== "free" &&
                      merchant?.customWidgetTheme?.textCustomization
                        ? merchant?.customWidgetTheme?.textCustomization?.valueOffCoupon?.replace(
                            "{{value}}",
                            `${merchant?.currency?.symbol}${merchant?.couponAmt}`
                          )
                        : `${merchant?.currency?.symbol}${
                            merchant?.couponAmt
                          } ${details.redeem_fixed_coupon.split("%")[1]}`,
                    desc: `${merchant?.redeemPoints} ${
                      merchant?.pointsCurrency !== "Super-Points"
                        ? merchant?.pointsCurrency
                        : details.main_points_title
                    } ${details.points_spent}`,
                    code,
                    imgUrl: fixedAmount("#262626"),
                  });
                  await fetchCustomer(customerId, shopDomain);
                  setLoading(false);
                  setIsDiscountCard(true);

                  window.scrollTo({
                    top: window.innerWidth < 768 ? 500 : 200,
                    behavior: "smooth",
                  });
                }
              }}
            />
          )}

        {!isFreeProductActive &&
          merchant?.waysToRedeem?.fixed &&
          merchant?.fixedCouponTierList
            ?.filter((tier) => getVIPTierEligibility("", tier?.eligibleVIPTier))
            ?.map((item, index) => {
              if (item?.pointsRedemptionStyle === "incremental") {
                return (
                  <RedeemPointsIncrementalCoupon
                    key={index}
                    merchantData={merchantData}
                    incrementalCoupon={item}
                    customerId={customerId}
                    customer={customer}
                    shopDomain={shopDomain}
                    fetchCustomer={fetchCustomer}
                    setCurrentDiscountCode={setCurrentDiscountCode}
                  />
                );
              }

              return (
                <WaysToRedeemItem
                  key={index}
                  imgUrl={
                    merchant?.theme?.icons?.fixed?.type === "custom"
                      ? merchant?.theme?.icons?.fixed?.location
                      : fixedAmount(
                          merchant?.customWidgetTheme?.iconcolor || "#262626"
                        )
                  }
                  title={
                    merchant?.currentPlan?.planName !== "free" &&
                    merchant?.customWidgetTheme?.textCustomization
                      ? merchant?.customWidgetTheme?.textCustomization?.valueOffCoupon?.replace(
                          "{{value}}",
                          `${merchant?.currency?.symbol}${item?.couponAmt}`
                        )
                      : `${merchant?.currency?.symbol}${item?.couponAmt} off coupon`
                  }
                  desc={`${item?.points} ${
                    merchant?.pointsCurrency !== "Super-Points"
                      ? merchant?.pointsCurrency
                      : "Points"
                  }`}
                  buttonText={
                    merchant?.currentPlan?.planName !== "free" &&
                    merchant?.customWidgetTheme?.textCustomization
                      ? merchant?.customWidgetTheme?.textCustomization
                          ?.redeemButton
                      : "Redeem"
                  }
                  isButton={customerId && customer?.points >= item?.points}
                  disabled={!(customerId && customer?.points >= item?.points)}
                  loading={loading}
                  onClickHandler={async () => {
                    if (customerId && customer?.points >= item.points) {
                      setLoading(true);
                      let { code, expiryDate } = await generateTierDiscountCode(
                        shopDomain,
                        customerId,
                        item
                      );
                      setCurrentDiscountCode({
                        text:
                          merchant?.currentPlan?.planName !== "free" &&
                          merchant?.customWidgetTheme?.textCustomization
                            ? merchant?.customWidgetTheme?.textCustomization?.valueOffCoupon?.replace(
                                "{{value}}",
                                `${merchant?.currency?.symbol}${item?.couponAmt}`
                              )
                            : `${currencySymbol}${item.couponAmt} ${
                                details.redeem_fixed_coupon.split("%")[1]
                              }`,
                        desc: `${item.points} ${
                          merchant?.pointsCurrency !== "Super-Points"
                            ? merchant?.pointsCurrency
                            : details.main_points_title
                        } ${details.points_spent}`,
                        code,
                        imgUrl: fixedAmount("#262626"),
                        selectedOrder: item.selectedOrder,
                        collectionName: item.collectionName,
                        expiryDate,
                      });
                      await fetchCustomer(customerId, shopDomain);
                      setLoading(false);
                      setIsDiscountCard(true);

                      window.scrollTo({
                        top: window.innerWidth < 768 ? 500 : 200,
                        behavior: "smooth",
                      });
                    }
                  }}
                />
              );
            })}

        {!isFreeProductActive &&
          merchant?.waysToRedeem?.percent &&
          merchant?.percentageAmt && (
            <WaysToRedeemItem
              imgUrl={
                merchant?.theme?.icons?.percent?.type === "custom"
                  ? merchant?.theme?.icons?.percent?.location
                  : percentageCoupon(
                      merchant?.customWidgetTheme?.iconcolor || "#262626"
                    )
              }
              title={
                merchant?.currentPlan?.planName !== "free" &&
                merchant?.customWidgetTheme?.textCustomization
                  ? merchant?.customWidgetTheme?.textCustomization?.valueOffCoupon?.replace(
                      "{{value}}",
                      `${merchant?.percentageAmt}%`
                    )
                  : `${merchant?.percentageAmt}% ${
                      details.redeem_fixed_coupon.split("%")[1]
                    }`
              }
              desc={`${merchant?.percentagePoints} ${
                merchant?.pointsCurrency !== "Super-Points"
                  ? merchant?.pointsCurrency
                  : details.main_points_title
              }`}
              buttonText={
                merchant?.currentPlan?.planName !== "free" &&
                merchant?.customWidgetTheme?.textCustomization
                  ? merchant?.customWidgetTheme?.textCustomization?.redeemButton
                  : "Redeem"
              }
              isButton={
                customerId && customer?.points >= merchant?.percentagePoints
              }
              disabled={
                !(customerId && customer?.points >= merchant?.percentagePoints)
              }
              loading={loading}
              onClickHandler={async () => {
                if (
                  customerId &&
                  customer?.points >= merchant?.percentagePoints
                ) {
                  setLoading(true);
                  let code = await generatePercentageCode(
                    shopDomain,
                    customerId
                  );
                  setCurrentDiscountCode({
                    text:
                      merchant?.currentPlan?.planName !== "free" &&
                      merchant?.customWidgetTheme?.textCustomization
                        ? merchant?.customWidgetTheme?.textCustomization?.valueOffCoupon?.replace(
                            "{{value}}",
                            `${merchant?.percentageAmt}%`
                          )
                        : `${merchant?.percentageAmt}% ${
                            details.redeem_fixed_coupon.split("%")[1]
                          }`,
                    desc: `${merchant?.percentagePoints} ${
                      merchant?.pointsCurrency !== "Super-Points"
                        ? merchant?.pointsCurrency
                        : details.main_points_title
                    } ${details.points_spent}`,
                    code,
                    imgUrl: percentageCoupon("#262626"),
                  });
                  await fetchCustomer(customerId, shopDomain);
                  setLoading(false);
                  setIsDiscountCard(true);
                  window.scrollTo({
                    top: window.innerWidth < 768 ? 500 : 200,
                    behavior: "smooth",
                  });
                }
              }}
            />
          )}
        {!isFreeProductActive &&
          merchant?.waysToRedeem?.percent &&
          merchant?.percentageCouponTierList
            ?.filter((tier) => getVIPTierEligibility("", tier?.eligibleVIPTier))
            ?.map((item, index) => (
              <WaysToRedeemItem
                key={index}
                imgUrl={
                  merchant?.theme?.icons?.percent?.type === "custom"
                    ? merchant?.theme?.icons?.percent?.location
                    : percentageCoupon(
                        merchant?.customWidgetTheme?.iconcolor || "#262626"
                      )
                }
                title={
                  merchant?.currentPlan?.planName !== "free" &&
                  merchant?.customWidgetTheme?.textCustomization
                    ? merchant?.customWidgetTheme?.textCustomization?.valueOffCoupon?.replace(
                        "{{value}}",
                        `${item?.percentageAmt}%`
                      )
                    : `${item?.percentageAmt}% off coupon`
                }
                desc={`${item?.points} ${
                  merchant?.pointsCurrency !== "Super-Points"
                    ? merchant?.pointsCurrency
                    : "Points"
                }`}
                buttonText={
                  merchant?.currentPlan?.planName !== "free" &&
                  merchant?.customWidgetTheme?.textCustomization
                    ? merchant?.customWidgetTheme?.textCustomization
                        ?.redeemButton
                    : "Redeem"
                }
                isButton={customerId && customer?.points >= item?.points}
                disabled={!(customerId && customer?.points >= item?.points)}
                loading={loading}
                onClickHandler={async () => {
                  if (customerId && customer?.points >= item.points) {
                    setLoading(true);

                    let { code, expiryDate } = await generateTierPercentCode(
                      shopDomain,
                      customerId,
                      item
                    );
                    setCurrentDiscountCode({
                      text:
                        merchant?.currentPlan?.planName !== "free" &&
                        merchant?.customWidgetTheme?.textCustomization
                          ? merchant?.customWidgetTheme?.textCustomization?.valueOffCoupon?.replace(
                              "{{value}}",
                              `${item?.percentageAmt}%`
                            )
                          : `${item.percentageAmt}% ${
                              details.redeem_fixed_coupon.split("%")[1]
                            }`,
                      desc: `${item.points} ${
                        merchant?.pointsCurrency !== "Super-Points"
                          ? merchant?.pointsCurrency
                          : details.main_points_title
                      } ${details.points_spent}`,
                      code,
                      imgUrl: percentageCoupon("#262626"),
                      selectedOrder: item.selectedOrder,
                      collectionName: item.collectionName,
                      expiryDate,
                    });
                    await fetchCustomer(customerId, shopDomain);
                    setLoading(false);
                    setIsDiscountCard(true);
                    window.scrollTo({
                      top: window.innerWidth < 768 ? 500 : 200,
                      behavior: "smooth",
                    });
                  }
                }}
              />
            ))}

        {!isFreeProductActive &&
          merchant?.waysToRedeem?.giftCard &&
          getVIPTierEligibility("giftcard") && (
            <RedeemPointsGiftcardItem
              imgUrl={
                merchant?.theme?.icons?.redeemGiftcard?.type === "custom"
                  ? merchant?.theme?.icons?.redeemGiftcard?.location
                  : giftcardIcon(
                      merchant?.customWidgetTheme?.iconcolor || "#262626"
                    )
              }
              title={
                merchant?.currentPlan?.planName !== "free" &&
                merchant?.theme?.textCustomization?.earnType
                  ? merchant?.theme?.textCustomization?.earnType
                      ?.redeemGiftcard ?? "Gift Card"
                  : "Gift Card"
              }
              desc={`${merchant?.giftCardRedeemPoints} ${
                merchant?.pointsCurrency !== "Super-Points"
                  ? merchant?.pointsCurrency
                  : details.main_points_title
              } = ${currencySymbol}1`}
              isButton={
                customerId && customer?.points >= merchant?.giftCardRedeemPoints
              }
              disabled={
                !(
                  customerId &&
                  customer?.points >= merchant?.giftCardRedeemPoints
                )
              }
              buttonText={
                merchant?.currentPlan?.planName !== "free" &&
                merchant?.customWidgetTheme?.textCustomization
                  ? merchant?.customWidgetTheme?.textCustomization?.redeemButton
                  : "Redeem"
              }
            />
          )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  customerData: state.CustomerReducer,
  merchantData: state.MerchantReducer,
  appStateData: state.AppstateReducer,
});

const mapDispatchToProps = (dispatch) => ({
  fetchCustomer: (customerId, shopDomain) =>
    dispatch(fetchCustomer(customerId, shopDomain)),
  setCurrentDiscountCode: (discountcode) =>
    dispatch(setCurrentDiscountCode(discountcode)),
  setIsDiscountCard: (state) => dispatch(setIsDiscountCard(state)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WaysToRedeemSection);
